module.exports = __webpack_public_path__ + "media/images/category/feature/echigo/kashiwazaki-ef9b39965361574320d3372045f694a0.gif";